export const getBackendPort = () => {
  const envPort = import.meta.env?.VITE_BACKEND_PORT;
  if (envPort) return envPort;

  if (typeof window !== "undefined") {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      return "8000";
    }
  }

  return "8200";
};

export const getApiUrl = () => {
  const envUrl = import.meta.env?.VITE_BACKEND_URL;
  if (envUrl) return envUrl.replace(/\/$/, "");

  const DEFAULT_URL = `http://localhost:${getBackendPort()}`;

  if (typeof window !== "undefined") {
    const { protocol, hostname } = window.location;

    // Si on est sur le domaine de prod, force l'API publique
    if (hostname.endsWith("autocerfa.eu")) {
      return "https://api.autocerfa.eu";
    }

    if (!hostname || protocol === "blob:" || protocol === "file:" || protocol === "about:") {
      return DEFAULT_URL;
    }

    const targetProtocol = protocol === "https:" ? "https:" : "http:";
    return `${targetProtocol}//${hostname}:${getBackendPort()}`;
  }

  return DEFAULT_URL;
};

export const API_URL = getApiUrl();
